import Login from '@/components/Login/index.js'
import Home from '@/components/Home/index.js'
import TransLog from '@/components/TransLog/index.js'
import ChangePassword from '@/components/ChangePassword/index.js'
import MaintainCarrier from '@/components/MaintainCarrier/index.js'
import MaintainCustomer from '@/components/MaintainCustomer/index.js'
import MaintainTransLog from '@/components/MaintainTransLog/index.js'
import MaintainTransLog_Sales from '@/components/MaintainTransLog_Sales/index.js'
import NewTrans from '@/components/NewTrans/index.js'
import ImportTrans from '@/components/ImportTrans/index.js'
import MaintainLogin from '@/components/MaintainLogin/index.js'
import PeriodSummary from '@/components/PeriodSummary/index.js'
import WHSummary from '@/components/WHSummary/index.js'
import testapi from '@/components/testapi'
import MaintainProduction from '@/components/MaintainProduction/index.js'
import MaintainStoreLog from '@/components/MaintainStoreLog/index.js'

import NotFound from '@/notFound.vue';

let routes = [
    {
        path:'/',name: 'default',
        //redirect: { Login }name: 'Login',
        component: Login
      },
      {
        path:'/Login',
        name: 'Login',
        component: Login
      },
      {
        path:'/testapi',
        name: 'testapi',
        component: testapi
      },
      {
        path:'/Home',
        name: 'Home',
        component: Home,
        children: [
          { name: 'TransLog', path: '/TransLog', component: TransLog },
          { name: 'NewTrans', path: '/NewTrans', component: NewTrans },
          { name: 'ChangePassword', path: '/ChangePassword', component: ChangePassword },
          { name: 'MaintainCarrier', path: '/MaintainCarrier', component: MaintainCarrier },
          { name: 'MaintainCustomer', path: '/MaintainCustomer', component: MaintainCustomer },
          { name: 'MaintainTransLog', path: '/MaintainTransLog', component: MaintainTransLog },
          { name: 'MaintainTransLog_Sales', path: '/MaintainTransLog_Sales', component: MaintainTransLog_Sales },
          { name: 'ImportTrans', path: '/ImportTrans', component: ImportTrans },
          { name: 'MaintainLogin', path: '/MaintainLogin', component: MaintainLogin },
          { name: 'PeriodSummary', path: '/PeriodSummary', component: PeriodSummary },
          { name: 'WHSummary', path: '/WHSummary', component: WHSummary },
          { name: 'MaintainProduction', path: '/MaintainProduction', component: MaintainProduction },
          { name: 'MaintainStoreLog', path: '/MaintainStoreLog', component: MaintainStoreLog },
          
        ]
      },
       { path: '/*', component: NotFound }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js